module.exports = __webpack_public_path__ + "img/cert2.d1e7df47.png";